var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1462_6314)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 23H16M36 24V21.2C36 20.0799 36 19.5198 35.782 19.092C35.5903 18.7157 35.2843 18.4097 34.908 18.218C34.4802 18 33.9201 18 32.8 18H19.2C18.0799 18 17.5198 18 17.092 18.218C16.7157 18.4097 16.4097 18.7157 16.218 19.092C16 19.5198 16 20.0799 16 21.2V28.8C16 29.9201 16 30.4802 16.218 30.908C16.4097 31.2843 16.7157 31.5903 17.092 31.782C17.5198 32 18.0799 32 19.2 32H25.5M32 34C32 34 35 32.5701 35 30.4252V27.9229L32.8124 27.1412C32.2868 26.9529 31.712 26.9529 31.1864 27.1412L29 27.9229V30.4252C29 32.5701 32 34 32 34Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1462_6314",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1462_6314"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1462_6314",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcons);
export default __webpack_public_path__ + "static/media/card-icons.d53948b88e2f496eac3ae11b05e47746.svg";
export { ForwardRef as ReactComponent };